import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';

import BreadcrumbsComponent from '../components/BreadcrumbsComponent';

import { getDirectoriesById } from '../actions/index';

const BreadcrumbsContainer = ({ breadcrumbs }) => {
  const [breadcrumbsBar, setBreadcrumbsBar] = useState(breadcrumbs || []);
  const dispatch = useDispatch();

  useEffect(() => {
    if (breadcrumbs !== breadcrumbsBar) {
      setBreadcrumbsBar(breadcrumbs);
    }
  });

  const breadcrumbsNavigateById = (dirID) =>
    getDirectoriesById(dispatch, {}, dirID);

  const breadcrumbsAction = (e) => {
    const { id, name } = e.target;
    const numberId = id.split('-').pop().toString();
    const splicedBreadcrumbs = breadcrumbsBar;
    breadcrumbsNavigateById(numberId).then(() => {
      splicedBreadcrumbs.length = Number(name) + 1;
      setBreadcrumbsBar(splicedBreadcrumbs);
    });
  };

  return (
    <BreadcrumbsComponent
      breadcrumbsBar={breadcrumbsBar}
      breadcrumbsAction={breadcrumbsAction}
    />
  );
};

BreadcrumbsContainer.propTypes = {
  breadcrumbs: PropTypes.instanceOf(Array),
};

export default BreadcrumbsContainer;
